module.exports = __webpack_public_path__ + "img/pexels-wavyvisuals-377312923-18948302.6e7eef20.jpg";